module.exports = __webpack_public_path__ + "img/bead__logo.13f2e97d.svg";